import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  InputAdornment,
  Avatar,
  Typography,
  Popover,
  Tab,
  ListItem,
  List,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { config } from "../../config/config";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MenuIcon from "@mui/icons-material/Menu";
import WindowSharpIcon from "@mui/icons-material/WindowSharp";
import TranslateSharpIcon from "@mui/icons-material/TranslateSharp";
import LogoutSharpIcon from "@mui/icons-material/LogoutSharp";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PersonIcon from "@mui/icons-material/Person";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import PeopleOutlineRoundedIcon from "@mui/icons-material/PeopleOutlineRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import LockIcon from "@mui/icons-material/Lock";
import FeedbackIcon from "@mui/icons-material/Feedback";
import HistoryIcon from "@mui/icons-material/History";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import useFetch from "../../componant/FetchData/useFetch";

const Header = ({ toggleSideNav }) => {
  const { name, roles } = useFetch();
  const location = useLocation();

  const [cookies, , removeCookie] = useCookies([config.cookieName]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState("1");
  const [activeItem, setActiveItem] = useState(0);
  const [openProfile, setOpenProfile] = useState(false);
  const isMobileScreen = useMediaQuery(
    "(min-width:360px) and (max-width:500px)"
  );
  const isSmallScreen = useMediaQuery(
    "(min-width:1024px) and (max-width:1440px)"
  );

  console.log(name, "stud");
  console.log(roles, "rol");
  const handleItemClick = (index) => {
    setActiveItem(index);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    removeCookie(config.cookieName);
    navigate("/");
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Grid
        sx={{
          width: isMobileScreen ? "100%" : "100%",
          height: isMobileScreen ? "40px" : isSmallScreen ? "60px" : "90px",
          background: "rgba(255, 255, 255, 0.7)",

          top: 0,
          position: "sticky",
          zIndex: 5,
        }}
      >
        <Grid
          container
          md={12}
          xs={12}
          sx={{
            px: isMobileScreen ? 1 : isSmallScreen ? 2 : 5,
            py: isMobileScreen ? 1 : isSmallScreen ? 2 : 3,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Grid
            item
            md={4}
            xs={0}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: isMobileScreen ? 2 : isSmallScreen ? 2 : 5,
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <MenuIcon
                sx={{
                  fontSize: isSmallScreen ? 20 : 25,
                  color: "#1d1a57",
                  display: isMobileScreen ? "none" : "block",
                }}
                onClick={toggleSideNav}
              />
            </Grid>
            <Grid sx={{ background: "#FFF", borderRadius: "5px" }}>
              <TextField
                type="text"
                size="small"
                value=""
                placeholder="search"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{
                          color: "#1D1A57",
                          fontSize: isMobileScreen ? 10 : "auto",
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  width: isMobileScreen ? "90px" : "200px",
                  fontSize: isMobileScreen ? 10 : isSmallScreen ? 12 : "auto",
                  "& .MuiInputBase-input": {
                    height: isMobileScreen
                      ? "6px"
                      : isSmallScreen
                      ? "12px"
                      : "15px",
                    fontSize: isMobileScreen ? 10 : isSmallScreen ? 12 : "auto",
                  },
                  border: "1px solid #1d1a57",
                  borderRadius: "5px",
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            md={4}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: isMobileScreen ? 2 : 4,
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WindowSharpIcon
                sx={{
                  fontSize: isMobileScreen ? 10 : isSmallScreen ? 20 : 25,
                  color: "#1d1a57",
                }}
              />
            </Grid>
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TranslateSharpIcon
                sx={{
                  fontSize: isMobileScreen ? 10 : isSmallScreen ? 20 : 25,
                  color: "#1d1a57",
                }}
              />
            </Grid>
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <NotificationsIcon
                sx={{
                  fontSize: isMobileScreen ? 10 : isSmallScreen ? 20 : 25,
                  color: "#1d1a57",
                }}
              />
            </Grid>
            <Grid
              sx={{
                width: isMobileScreen ? 15 : isSmallScreen ? 30 : 40,
                height: isMobileScreen ? 15 : isSmallScreen ? 30 : 40,
              }}
            >
              <Avatar
                onClick={handleClick}
                sx={{
                  width: isMobileScreen ? 15 : isSmallScreen ? 30 : 40,
                  height: isMobileScreen ? 15 : isSmallScreen ? 30 : 40,
                  cursor: "pointer",
                  backgroundColor: "#1D1A57",
                  borderRadius: "50%",
                }}
              />
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                sx={{
                  mt: 1,
                }}
                PaperProps={{
                  sx: {
                    borderRadius: 3,
                  },
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 20,
                    py: isMobileScreen ? 1 : 2,
                    width: isMobileScreen ? "175px" : "300px",
                  }}
                >
                  <Grid
                    container
                    md={12}
                    xs={12}
                    sx={{
                      width: "90%",
                      borderRadius: 10,

                      height: "auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mx: isMobileScreen ? 1 : 2,
                    }}
                  >
                    <Grid
                      item
                      md={9}
                      xs={9}
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Grid>
                        <Avatar
                          sx={{
                            width: isMobileScreen ? 20 : 40,
                            height: isMobileScreen ? 20 : 40,
                            cursor: "pointer",
                            backgroundColor: "#1D1A57",
                            borderRadius: "50%",
                          }}
                        />
                      </Grid>

                      <Grid sx={{ mx: isMobileScreen ? 1 : 2 }}>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: isMobileScreen ? "12px" : "16px",
                          }}
                        >
                          {name}
                        </Typography>
                        <Typography
                          sx={{
                            color: "#95959B",
                            fontSize: isMobileScreen ? "8px" : "13px",
                          }}
                        >
                          {roles}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      md={3}
                      xs={3}
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        cursor: "pointer",
                      }}
                      onClick={handleLogout}
                    >
                      <LogoutSharpIcon
                        sx={{
                          color: "#1D1A57",
                          fontSize: isMobileScreen ? 15 : 25,
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid sx={{ mt: isMobileScreen ? 1 : 3 }}>
                    <TabContext value={value}>
                      <Box
                        sx={{
                          // marginBottom: "10px",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#FFF",
                          "& .MuiTabs-flexContainer": {
                            flexWrap: "nowrap",
                          },
                          "& .MuiTabs-indicator": {
                            background: "#1d1a57",
                          },
                          boxShadow: 1,
                        }}
                      >
                        <TabList
                          onChange={handleChange}
                          aria-label="lab API tabs example"
                          sx={{
                            width: "100%",
                            "& .MuiTab-root": {
                              fontSize: isMobileScreen ? "10px" : "14px",
                              fontWeight: 600,
                              background: "#FFF",
                              minWidth: 0,
                              "&.Mui-selected": {
                                color: "#1d1a57",
                              },
                            },
                          }}
                        >
                          <Tab
                            label={
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span style={{ marginRight: 10 }}>
                                    <PersonOutlinedIcon
                                      sx={{
                                        color: "#1D1A57",
                                        fontSize: isMobileScreen ? 15 : 25,
                                      }}
                                    />
                                  </span>
                                  <span
                                    style={{
                                      textTransform: "capitalize",
                                      fontSize: isMobileScreen ? 12 : 16,
                                    }}
                                  >
                                    Profile
                                  </span>
                                </div>
                              </>
                            }
                            value="1"
                            sx={{ width: "50%" }}
                          />
                          <Tab
                            label={
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span style={{ marginRight: 10 }}>
                                    <SettingsOutlinedIcon
                                      sx={{
                                        color: "#1D1A57",
                                        fontSize: isMobileScreen ? 15 : 25,
                                      }}
                                    />
                                  </span>
                                  <span
                                    style={{
                                      textTransform: "capitalize",
                                      fontSize: isMobileScreen ? 12 : 16,
                                    }}
                                  >
                                    Settings
                                  </span>
                                </div>
                              </>
                            }
                            value="2"
                            sx={{ width: "50%" }}
                          />
                        </TabList>
                      </Box>
                      <TabPanel
                        value="1"
                        sx={{
                          "&.MuiTabPanel-root": {
                            px: isMobileScreen ? 1 : 2,
                            py: isMobileScreen ? 0 : "2px",
                          },
                        }}
                      >
                        <List sx={{ cursor: "pointer" }}>
                          <ListItem
                            onClick={() => handleItemClick(0)}
                            sx={{
                              color: activeItem === 0 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 0 ? "#f0f8ff" : "#FFF",
                              borderRadius: 1,
                              "&:hover": {
                                background:
                                  activeItem === 0 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                              my: isMobileScreen ? 0 : 1,
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <BorderColorRoundedIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              Edit Profile
                            </Typography>
                          </ListItem>
                          <ListItem
                            onClick={() => {
                              handleItemClick(1);
                              setOpenProfile(true);
                              handleClose();
                              navigate("/myprofile");
                            }}
                            sx={{
                              color: activeItem === 1 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 1 ? "#f0f8ff" : "#FFF",
                              "&:hover": {
                                background:
                                  activeItem === 1 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                              borderRadius: 1,
                              my: isMobileScreen ? 0 : 1,
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <PersonOutlinedIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              View Profile
                            </Typography>
                          </ListItem>
                          <ListItem
                            onClick={() => handleItemClick(2)}
                            sx={{
                              color: activeItem === 2 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 2 ? "#f0f8ff" : "#FFF",
                              borderRadius: 1,
                              "&:hover": {
                                background:
                                  activeItem === 2 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                              my: isMobileScreen ? 0 : 1,
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <PeopleOutlineRoundedIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              Profile
                            </Typography>
                          </ListItem>
                          <ListItem
                            onClick={() => handleItemClick(3)}
                            sx={{
                              color: activeItem === 3 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 3 ? "#f0f8ff" : "#FFF",
                              borderRadius: 1,
                              "&:hover": {
                                background:
                                  activeItem === 3 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <ReceiptLongRoundedIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              Billing
                            </Typography>
                          </ListItem>
                          <ListItem
                            onClick={() => {
                              handleItemClick(4);
                              handleLogout();
                            }}
                            sx={{
                              color: activeItem === 4 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 4 ? "#f0f8ff" : "#FFF",
                              borderRadius: 1,
                              "&:hover": {
                                background:
                                  activeItem === 4 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                              my: isMobileScreen ? 0 : 1,
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <LogoutRoundedIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              Logout
                            </Typography>
                          </ListItem>
                        </List>
                      </TabPanel>
                      <TabPanel
                        value="2"
                        sx={{
                          "&.MuiTabPanel-root": {
                            px: isMobileScreen ? 1 : 2,
                            py: isMobileScreen ? 0 : "2px",
                          },
                        }}
                      >
                        <List sx={{ cursor: "pointer" }}>
                          <ListItem
                            onClick={() => handleItemClick(0)}
                            sx={{
                              color: activeItem === 0 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 0 ? "#f0f8ff" : "#FFF",
                              borderRadius: 1,
                              "&:hover": {
                                background:
                                  activeItem === 0 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                              my: isMobileScreen ? 0 : 1,
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <SupportAgentIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              Support
                            </Typography>
                          </ListItem>
                          <ListItem
                            onClick={() => handleItemClick(1)}
                            sx={{
                              color: activeItem === 1 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 1 ? "#f0f8ff" : "#FFF",
                              borderRadius: 1,
                              "&:hover": {
                                background:
                                  activeItem === 1 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <PersonIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              Account Settings
                            </Typography>
                          </ListItem>
                          <ListItem
                            onClick={() => handleItemClick(2)}
                            sx={{
                              color: activeItem === 2 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 2 ? "#f0f8ff" : "#FFF",
                              borderRadius: 1,
                              "&:hover": {
                                background:
                                  activeItem === 2 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                              my: isMobileScreen ? 0 : 1,
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <LockIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              Privacy Center
                            </Typography>
                          </ListItem>
                          <ListItem
                            onClick={() => handleItemClick(3)}
                            sx={{
                              color: activeItem === 3 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 3 ? "#f0f8ff" : "#FFF",
                              borderRadius: 1,
                              "&:hover": {
                                background:
                                  activeItem === 3 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                              my: isMobileScreen ? 0 : 1,
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <FeedbackIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              Feedback
                            </Typography>
                          </ListItem>
                          <ListItem
                            onClick={() => handleItemClick(4)}
                            sx={{
                              color: activeItem === 4 ? "#1D1A57" : "#5B6B79",
                              background: activeItem === 4 ? "#f0f8ff" : "#FFF",
                              borderRadius: 1,
                              "&:hover": {
                                background:
                                  activeItem === 4 ? "#FFF" : "#FAF9F6",
                                borderRadius: 1,
                              },
                              my: isMobileScreen ? 0 : 1,
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                letterSpacing: isMobileScreen ? 0 : "1px",
                                fontSize: isMobileScreen ? 12 : 16,
                              }}
                            >
                              <HistoryIcon
                                sx={{
                                  mr: isMobileScreen ? 1 : 3,
                                  fontSize: isMobileScreen ? 15 : 25,
                                }}
                              />
                              History
                            </Typography>
                          </ListItem>
                        </List>
                      </TabPanel>
                    </TabContext>
                  </Grid>
                </Grid>
              </Popover>
            </Grid>
          </Grid>
        </Grid>
        <Grid></Grid>
      </Grid>
    </>
  );
};

export default Header;
